/* eslint-disable no-unused-vars */
import AsyncStorage from '@react-native-async-storage/async-storage';
import { MsB2b } from '@api/ms-b2b';
import { storageName } from '@global/background';

// processing to submit activity task
const processActivityTaskQueue = async (payload = []) => {
  // get pending or failed queue
  let isDone = false;
  const storages =
    payload.length > 0
      ? payload
      : await AsyncStorage.getItem(storageName.activityTask);
  if (storages) {
    const queues = payload.length > 0 ? payload : JSON.parse(storages);
    if (queues?.length) {
      const results = [];
      for (let i = 0; i < queues.length; i++) {
        const item = queues[i];
        console.log(
          `Processing: Submit Activity ${item.activityId} Task ${item.taskId}`,
        );
        results.push({
          ...item,
          process: 1,
        });

        try {
          // submit activity task
          let res = null;

          if (item?.type == 'visibility_update') {
            res = await MsB2b.activityTodosTypeUpdate(
              item.activityId,
              item.taskId,
              item.type,
              item.payload,
            );
          } else {
            res = await MsB2b.activityTodosUpdate(
              item.activityId,
              item.taskId,
              item.payload,
            );
          }

          if (res?.data?.data) {
            isDone = true;
            results[i].process = 2;
            console.log(
              `Processed: Submit Activity ${item.activityId} Task ${item.taskId}`,
            );
          }
        } catch (error) {
          // rollback when process is failed
          results[i].process = 0;
          console.log(
            `Failed: Submit Activity ${item.activityId} Task ${item.taskId}`,
          );
        }
      }
      // updating queue list
      await AsyncStorage.setItem(
        storageName.activityTask,
        JSON.stringify(results),
      );
      if (results.findIndex((r) => r.process == 2) > -1) {
        // remove activity task process done
        const finalResult = results.filter((r) => r.process != 2);
        await AsyncStorage.setItem(
          storageName.activityTask,
          JSON.stringify(finalResult),
        );

        const finalResultDone = results.filter((r) => r.process == 2);
        await AsyncStorage.setItem(
          storageName.activityTaskDone,
          JSON.stringify(finalResultDone),
        );
      }
    }
  }
  return isDone;
};

export { processActivityTaskQueue };
